export const questions = [
    {
        id: 1,
        question: "How would you describe your business's approach to change?",
        options: [
            { id: 'a', text: "We're always a step ahead, forecasting the next big thing.", outcomeId: 1, image: '/quizzes/personality/assets/images/q1/q1a.webp' },
            { id: 'b', text: "We try to adapt, but sometimes it feels like catching up.", outcomeId: 2, image: '/quizzes/personality/assets/images/q1/q1b.webp' },
            { id: 'c', text: "Change? What's that? We're more the 'if it ain't broke' type.", outcomeId: 3, image: '/quizzes/personality/assets/images/q1/q1c.webp' },
            { id: 'd', text: "We're traditional but looking for ways to modernize.", outcomeId: 4, image: '/quizzes/personality/assets/images/q1/q1d.webp' }
        ]
    },
    {
        id: 2,
        question: "When faced with a challenge, what does your company usually do?",
        options: [
            { id: 'a', text: "Dive deep into research and customer insights.", outcomeId: 4, image: '/quizzes/personality/assets/images/q2/q2a.webp' },
            { id: 'b', text: "Host brainstorming sessions, hoping creativity sparks.", outcomeId: 2, image: '/quizzes/personality/assets/images/q2/q2b.webp' },
            { id: 'c', text: "Look at what competitors are doing and try to match their efforts.", outcomeId: 3, image: '/quizzes/personality/assets/images/q2/q2c.webp' },
            { id: 'd', text: "Seek out experts or partners to guide us.", outcomeId: 1, image: '/quizzes/personality/assets/images/q2/q2d.webp' }
        ]
    },
    {
        id: 3,
        question: "How would you describe your company's relationship with technology?",
        options: [
            { id: 'a', text: "Tech-savvy leaders – always exploring the newest tools.", outcomeId: 1, image: '/quizzes/personality/assets/images/q3/q3a.webp' },
            { id: 'b', text: "Comfortable, but always open to learning more.", outcomeId: 2, image: '/quizzes/personality/assets/images/q3/q3b.webp' },
            { id: 'c', text: "We rely on legacy systems but know we need an upgrade.", outcomeId: 3, image: '/quizzes/personality/assets/images/q3/q3c.webp' },
            { id: 'd', text: "Technology is a tool, not necessarily our strength.", outcomeId: 4, image: '/quizzes/personality/assets/images/q3/q3d.webp' }
        ]
    },
    {
        id: 4,
        question: "How do you feel about your current product strategy?",
        options: [
            { id: 'a', text: "It's visionary and leading the market.", outcomeId: 1, image: '/quizzes/personality/assets/images/q4/q4a.webp' },
            { id: 'b', text: "It works for now, but there's room for innovation.", outcomeId: 2, image: '/quizzes/personality/assets/images/q4/q4b.webp' },
            { id: 'c', text: "Strategy? We could use some direction there.", outcomeId: 3, image: '/quizzes/personality/assets/images/q4/q4c.webp' },
            { id: 'd', text: "It's been the same for years, but we're open to change.", outcomeId: 4, image: '/quizzes/personality/assets/images/q4/q4d.webp' }
        ]
    },
    {
        id: 5,
        question: "How often do you engage with your customers for feedback?",
        options: [
            { id: 'a', text: "Regularly. They drive our next moves.", outcomeId: 1, image: '/quizzes/personality/assets/images/q5/q5a.webp' },
            { id: 'b', text: "Occasionally, when launching something new.", outcomeId: 2, image: '/quizzes/personality/assets/images/q5/q5b.webp' },
            { id: 'c', text: "Rarely, unless there's a major issue.", outcomeId: 3, image: '/quizzes/personality/assets/images/q5/q5c.webp' },
            { id: 'd', text: "We rely on market trends more than direct feedback.", outcomeId: 4, image: '/quizzes/personality/assets/images/q5/q5d.webp' }
        ]
    },
    {
        id: 6,
        question: "How do you prefer to collaborate with partners or consultants?",
        options: [
            { id: 'a', text: "We're an open book. We immerse them in all aspects of our business.", outcomeId: 4, image: '/quizzes/personality/assets/images/q6/q6a.webp' },
            { id: 'b', text: "Collaboration is key. Regular brainstorming and feedback sessions are essential.", outcomeId: 2, image: '/quizzes/personality/assets/images/q6/q6b.webp' },
            { id: 'c', text: "We prefer set milestones and check-ins to ensure project progress.", outcomeId: 1, image: '/quizzes/personality/assets/images/q6/q6c.webp' },
            { id: 'd', text: "We seek guidance but generally keep decision-making in-house.", outcomeId: 3, image: '/quizzes/personality/assets/images/q6/q6d.webp' }
        ]
    }
];

export const outcomes = [
    {
        id: 1,
        title: "You are a Visionary Vanguard",
        description: "You're always ahead of the curve, leading the industry with your forward-thinking approach. With argodesign's Product Strategy, we can further harness your innovative spirit to identify untapped opportunities and solidify your leadership position.",
        image: '/quizzes/personality/assets/images/outcomes/01.webp',
        cta: "Reach out to us"
    },
    {
        id: 2,
        title: "You are a Creative Collaborator",
        description: "You value creativity and the power of brainstorming. Partnering with argodesign for Product Innovation will take your ideas from sparks to reality, ensuring they're technologically savvy and deeply creative.",
        image: '/quizzes/personality/assets/images/outcomes/02.webp',
        cta: "Let's collaborate"
    },
    {
        id: 3,
        title: "You are a Traditional Transformer",
        description: "While you've achieved success with tried-and-true methods, you're aware of the need to modernize. argodesign's Digital Transformation service is perfect for you, helping to rejuvenate your operations and engage with your market in exciting new ways.",
        image: '/quizzes/personality/assets/images/outcomes/03.webp',
        cta: "Connect with us"
    },
    {
        id: 4,
        title: "You are a Inquisitive Innovator",
        description: "Research and customer feedback are your bread and butter. With argodesign's expert tools and methods that create clarity, we can further refine your approach to achieve even greater results and impact. Excited about a deep dive into innovation?",
        cta: "Start a conversation with us",
        image: '/quizzes/personality/assets/images/outcomes/04.webp'
    }
];
